{
  const navTrigger = [
    ...document.getElementsByClassName("site-header__trigger") // Spead HTMLCollection into Array
  ];

  const navCloseTrigger = [
    ...document.getElementsByClassName("site-header__close") // Spead HTMLCollection into Array
  ];

  // Toggle Data Attr value
  const toggleNavigation = function() {
    const navigationPanel = document.getElementById("navigation-panel");
    const page = document.documentElement;

    navigationPanel.setAttribute(
      "data-state",
      navigationPanel.getAttribute("data-state") === "open" ? "closed" : "open"
    );

    page.setAttribute(
      "data-state",
      page.getAttribute("data-state") === "open" ? "closed" : "open"
    );
  };

  // Event Listner added
  navTrigger.forEach(element => {
    element.addEventListener("click", toggleNavigation);
  });

  navCloseTrigger.forEach(element => {
    element.addEventListener("click", toggleNavigation);
  });
}
